import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      margin: '0 8px'
    }
  })
);

function MiddleDot() {
  const classes = useStyles({});
  return (
    <Typography color="textSecondary" display="inline" className={classes.root} >
      &bull;
    </Typography>
  );
};

export default MiddleDot;
